import { forwardRef } from "react";

import { Button } from "components";
import styles from "features/filters/components/Filters.module.css";
import { LineClamp } from "utils";

export interface FilterButtonProps {
  label: string;
  active?: boolean;
  onClick: () => void;
  badge?: string;
  refKey: string;
}

// Use forwardRef if you need to pass refs from Filters (for positioning/alignment)
export const FilterButton = forwardRef<HTMLDivElement, FilterButtonProps>(
  ({ label, active, onClick, badge, refKey }, ref) => (
    <div
      ref={ref}
      className={`${styles.filterButton} ${active ? styles.active : ""}`}
      data-key={refKey}
      data-filter-button
    >
      <Button size="sm" variant="secondary" onClick={onClick}>
        {badge && <span className={styles.badge}>{badge}</span>}
        <LineClamp text={label} lines={1} className={styles.label} />
      </Button>
    </div>
  )
);

FilterButton.displayName = "FilterButton";
